// import packages
import React from "react"
import { CSVLink } from "react-csv"
import ReactTable from "react-table"
import { Link } from "react-router-dom"
import PropTypes from "prop-types"
import { Card, CardBody, Button } from "reactstrap"
import _ from "lodash"
import UploadSection from "modules/data-import/UploadSection"
import withModal from "../../modal"
import { CreateButton, TrashButton, SettingButton } from "../index"

const CustomReactTableWithoutGql = props => {
  const {
    modal,
    // deleteObjectGql,
    // queryObjectGql,
    fieldsDefGql,
    objectName,
    objectRoute,
    fieldsDef,
    hasCreateButton,
    hasDeleteButton,
    hasEditButton,
    hasSettingButton,
    hasDownloadButton,
    hasUploadButton,
    showPagination,
    defaultPageSize,
    columStyle,
    uploadSettings,
    data,
    deleteCallback,
    refetchCallback
  } = props

  const fields = {}

  const showUploadModal = callback => {
    modal.reset()
    modal.setOnSubmit(callback)
    modal.setHeaderText("匯入資料")
    modal.setSubmitText("關閉")
    modal.setHideCancel(true)
    modal.setModalSize("m")
    modal.setModalContent(
      <UploadSection
        typeName={uploadSettings.typeName}
        description={uploadSettings.description}
        sampleUrl={uploadSettings.sampleUrl}
        uploadType={uploadSettings.uploadType}
      />
    )
    modal.toggle()
  }

  const renderCreateButton = () => {
    return (
      <Link to={`${objectRoute}/detail`}>
        <CreateButton>新增{objectName}</CreateButton>
      </Link>
    )
  }

  const renderSettingButton = () => {
    return <SettingButton id="setting" style={{ marginLeft: "auto" }} />
  }

  const renderUploadButton = () => {
    return (
      <Button
        onClick={e => {
          e.preventDefault()
          showUploadModal(() => {
            refetchCallback()
          })
        }}
        size="sm"
        round="true"
        icon="true"
        className="mr-2"
      >
        <i className="mdi mdi-cloud-upload" />
      </Button>
    )
  }

  const renderDownloadButton = () => {
    if (!data) {
      return <div />
    }

    return (
      <CSVLink filename={`${objectName}資料.csv`} separator={";"}>
        <Button size="sm" round="true" icon="true" className="mr-2">
          <i className="fas fa-download" />
        </Button>
      </CSVLink>
    )
  }

  const showConfirmModal = callback => {
    modal.reset()
    modal.setOnSubmit(callback)
    modal.setHeaderText("提示")
    modal.setModalContent(`確認是否要刪除${objectName}`)
    modal.toggle()
  }

  const renderDeleteButton = id => {
    return (
      <TrashButton
        onClick={() => {
          showConfirmModal(() => {
            deleteCallback(id)
          })
        }}
      />
    )
  }

  const renderEditButton = id => {
    return (
      <div style={{ textAlign: "center" }}>
        <Link to={`${objectRoute}/detail/${id}`}>
          <Button size="sm" round="true" icon="true" color="inverse">
            <i className="fa fa-edit" />
          </Button>
        </Link>
      </div>
    )
  }

  const getSortedFields = (fields: Array, fieldsDef: Array) => {
    if (!fields || !hasSettingButton) {
      return fieldsDef
    }
    const sortedData = _(fields[Object.keys(fields)[0]])
      .filter({ show: true })
      .sortBy(["order"])
      .value()
    const sortedFieldsDef = sortedData.map(item => {
      return fieldsDef.filter(def => def.id === item.name)[0]
    })
    return sortedFieldsDef
  }

  const getColumnDefinitions = () => {
    const definitions = []
    definitions.push({
      Header: "id",
      accessor: "id",
      show: false
    })
    if (hasEditButton) {
      definitions.push({
        Header: "編輯",
        style: columStyle || defaultColumnStyle,
        width: 60,
        Cell: cell => {
          return renderEditButton(cell.row.id)
        }
      })
    }
    definitions.push(...getSortedFields(fields, fieldsDef))
    if (hasDeleteButton) {
      definitions.push({
        Header: "刪除",
        width: 60,
        style: columStyle || defaultColumnStyle,
        Cell: cell => {
          return renderDeleteButton(cell.row.id)
        }
      })
    }
    return definitions
  }

  return (
    <>
      <Card>
        <CardBody>
          <div className="d-flex justify-content-between align-items-center content mb-3">
            <div>{hasCreateButton && renderCreateButton()}</div>
            <div>
              {hasUploadButton && uploadSettings && renderUploadButton()}
              {hasDownloadButton && renderDownloadButton()}
              {hasSettingButton && fieldsDefGql && renderSettingButton()}
            </div>
          </div>
          <ReactTable
            defaultPageSize={defaultPageSize || 10}
            onFilteredChange={() => {}}
            getTdProps={() => ({
              style: {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center"
              }
            })}
            data={data || []}
            columns={[...getColumnDefinitions()]}
            showPagination={showPagination || true}
            defaultSorted={props.defaultSorted}
          >
            {(state, makeTable) => {
              // setSortedData(state.sortedData)
              return makeTable()
            }}
          </ReactTable>
        </CardBody>
      </Card>
    </>
  )
}
const defaultColumnStyle = { whiteSpace: "unset", textAlign: "center" }

CustomReactTableWithoutGql.propTypes = {
  fieldsDef: PropTypes.array.isRequired,
  objectName: PropTypes.string.isRequired,
  fieldsDefGql: PropTypes.object,
  objectRoute: PropTypes.string,
  fieldsDefKey: PropTypes.string,
  hasCreateButton: PropTypes.bool,
  hasDeleteButton: PropTypes.bool,
  hasEditButton: PropTypes.bool,
  hasSettingButton: PropTypes.bool,
  hasUploadButton: PropTypes.bool,
  hasDownloadButton: PropTypes.bool,
  showPagination: PropTypes.bool,
  defaultPageSize: PropTypes.bool,
  columnStyle: PropTypes.object,
  uploadSettings: PropTypes.object
}

export default withModal(CustomReactTableWithoutGql)
